export default "__VITE_ASSET__b8a2738f__"